import React from 'react';
import IconBase from './IconBase';
const HamburgerIcon = props => React.createElement(IconBase, props, React.createElement("line", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x1: "3.601",
  y1: "10.069",
  x2: "60.473",
  y2: "10.069"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x1: "23.127",
  y1: "31.898",
  x2: "60.473",
  y2: "31.898"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x1: "3.601",
  y1: "53.728",
  x2: "60.473",
  y2: "53.728"
}));
HamburgerIcon.displayName = 'HamburgerIcon';
export default HamburgerIcon;
//# sourceMappingURL=HamburgerIcon.js.map